import { createSlice } from '@reduxjs/toolkit'
import { messagesTexts } from 'locale/es'
import messageService from 'services/MessagesService'
import { toast } from './notificationReducer'

const initialState = { data: [], loading: false, error: null }

const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessages(state, action) {
      const { data } = action.payload

      return { ...state, data, loading: false, error: null }
    },
    appendMessage(state, action) {
      const { data } = action.payload

      return { ...state, data: [...state.data, data], loading: false, error: null }
    },
    updateMessage(state, action) {
      const { data } = action.payload

      const updatedMessages = state.data.map((message) =>
        message.id !== data.id ? message : data
      )

      return { ...state, data: updatedMessages, loading: false, error: null }
    },
    deleteMessage(state, action) {
      const newDataState = state.data.filter((message) => message.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null, }
    },
    setMessagesLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setMessagesError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetMessagesState(state, action) {
      return initialState
    }
  },
})

export const { setMessages, appendMessage, updateMessage, deleteMessage, setMessagesLoading, setMessagesError, resetMessagesState } =
  messageSlice.actions

export const initializePatientMessages = (userId) => {
  return async (dispatch) => {
    try {
      dispatch(setMessagesLoading())

      const { data } = await messageService.getAll(userId)

      dispatch(setMessages({ data }))
    }
    catch (error) {
      console.error(error)
      dispatch(setMessagesError({ message: error.message, status: error.response?.status }));
      dispatch(toast(messagesTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const createMessage = (messageObj) => {
  return async (dispatch) => {
    try {
      const { data } = await messageService.create(messageObj)
      dispatch(appendMessage({ data }))
      dispatch(toast(messagesTexts.CREATED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setMessagesError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const updateMessageAction = (fieldsToUpdate) => {
  return async (dispatch) => {
    try {
      const { data } = await messageService.update(fieldsToUpdate.id, fieldsToUpdate)
      dispatch(updateMessage({ data }))
      dispatch(toast(messagesTexts.EDITED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setMessagesError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const deleteMessageAction = (id) => {
  return async (dispatch) => {
    try {
      await messageService.remove(id)
      dispatch(deleteMessage(id))
      dispatch(toast(messagesTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setMessagesError({ message: error.message, status: error.response?.status }));
      dispatch(toast(messagesTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default messageSlice.reducer